import { useFilter } from '../../hooks/useFilter';
import { DayPicker } from 'react-day-picker';
import 'react-day-picker/dist/style.css';
import { es, ptBR } from "date-fns/locale";
import { useTranslation } from "react-i18next";
import './styles.css'

type DaySelectProps = {
    selectOnlyMonth: boolean;
    maxDate: Date;
}

export default function DaySelect({ selectOnlyMonth = false, maxDate = new Date() }: DaySelectProps) {
    const { i18n } = useTranslation();
    const {
        focusLastDay,
        setFocusLastDay,
        viewRangeDays,
        selectedDates,
        setSelectedDates,
        setViewRangeDays,
        onBoardingDate
    } = useFilter();

    function handleDayClick(day: Date) {
        const now = day;
        const firstDayOfCurrentMonth = new Date(now.getFullYear(), now.getMonth(), 1);

        const from = selectOnlyMonth
            ? (focusLastDay ? selectedDates?.from : firstDayOfCurrentMonth)
            : (focusLastDay ? selectedDates?.from : day);

        const to = focusLastDay ? day : selectedDates?.to;

        const minDate = from! <= to! ? from : to;
        const maxDate = from! <= to! ? to : from;

        setSelectedDates({ from: minDate, to: maxDate });
        setFocusLastDay(!focusLastDay)
    }

    function handleDayMouseEnter(day: Date) {
        const newRange = {
            from: focusLastDay ? selectedDates?.from : day,
            to: focusLastDay ? day : selectedDates?.to,
        };

        if (!focusLastDay && day >= selectedDates?.to!) {
            newRange.from = selectedDates?.to;
            newRange.to = day;
        }

        if (focusLastDay && day <= selectedDates?.from!) {
            newRange.from = day;
            newRange.to = selectedDates?.from;
        }

        setViewRangeDays(newRange);
    }

    const markDays = [
        selectedDates?.from ?? undefined,
        selectedDates?.to ?? undefined,
    ];

    return (
        <div onMouseLeave={() => {
            setViewRangeDays(selectedDates)
        }}>
            <DayPicker
                mode="range"
                selected={viewRangeDays}
                fromDate={onBoardingDate}
                toDate={maxDate}
                onDayMouseEnter={handleDayMouseEnter}
                onDayClick={handleDayClick}
                showOutsideDays
                fixedWeeks
                modifiers={{
                    selectedRange: selectedDates ? markDays.filter((day): day is Date => day !== undefined) : []
                }}
                modifiersClassNames={{
                    selectedRange: "rpd-days-range_selected"
                }}
                locale={i18n.language.startsWith("es") ? es : ptBR}
            />
        </div>
    );
}
